import { useContext, useState } from 'react';

import BpkSelectableChip from '@skyscanner-internal/backpack-web/bpk-component-chip';
import BpkMobileScrollContainer from '@skyscanner-internal/backpack-web/bpk-component-mobile-scroll-container';
import reactReplacePlaceholder from 'react-replace-placeholder';

import StringsContext from '../Contexts/StringsContext';
import { BOARD_TYPE } from '../server/constants';

import type { Board } from '../ArrivalsDeparturesBoardReducer';

import STYLES from './FlightChipGroup.module.scss';

export interface FlightChipsProps {
  airportName: string;
  currentBoard: string;
  onChipClick: (selectedChip: Board) => void;
}

const FlightChipGroup = ({
  airportName,
  currentBoard,
  onChipClick,
}: FlightChipsProps) => {
  const strings = useContext(StringsContext);
  const [scrollerRef, setScrollerRef] = useState<HTMLElement | null>(null);

  const arrivalsChipLabel = reactReplacePlaceholder(
    strings.falcon_adb_arrivals_chip,
    { airport_name: airportName },
    '@@',
    '@@',
  ).join('');
  const departuresChipLabel = reactReplacePlaceholder(
    strings.falcon_adb_departures_chip,
    { airport_name: airportName },
    '@@',
    '@@',
  ).join('');

  const handleChipClick = (board: keyof typeof BOARD_TYPE) => {
    scrollerRef?.scrollTo({
      left: board === BOARD_TYPE.ARRIVALS ? 0 : scrollerRef?.scrollWidth,
      behavior: 'smooth',
    });

    onChipClick(board);
  };

  return (
    <div className={STYLES.FlightChipGroup}>
      <BpkMobileScrollContainer scrollerRef={(el) => setScrollerRef(el)}>
        <div className={STYLES.mobile_scroll_container_body}>
          <BpkSelectableChip
            accessibilityLabel={arrivalsChipLabel}
            name={BOARD_TYPE.ARRIVALS}
            selected={currentBoard === BOARD_TYPE.ARRIVALS}
            onClick={() => handleChipClick(BOARD_TYPE.ARRIVALS)}
          >
            {arrivalsChipLabel}
          </BpkSelectableChip>
          <BpkSelectableChip
            accessibilityLabel={departuresChipLabel}
            name={BOARD_TYPE.DEPARTURES}
            selected={currentBoard === BOARD_TYPE.DEPARTURES}
            onClick={() => handleChipClick(BOARD_TYPE.DEPARTURES)}
          >
            {departuresChipLabel}
          </BpkSelectableChip>
        </div>
      </BpkMobileScrollContainer>
    </div>
  );
};

export default FlightChipGroup;
